export default __webpack_public_path__ + "static/media/practo1.56e6a11b.png";